import { useTranslations } from 'next-intl';

import BenefitIcon from '@/fo/icons/base/doctor/benefit.svg';
import { UiDoctorSelectorCity } from '@/fo/ui/doctor/selector/city';
import { utilPluralize } from '@/fo/util/pluralize';

import { Clinic, Doctor } from '../../types';

import { styles } from './Appointment.styles';

export const Appointment = ({ doctor }: { doctor: Doctor }) => {
  const slots = styles();
  const t = useTranslations();
  const pluralizeClinics = utilPluralize({
    one: t('pluralize.clinics.one'),
    few: t('pluralize.clinics.few'),
    many: t('pluralize.clinics.many')
  });

  if (!doctor) return null;

  return (
    <div className={slots.base()}>
      <div className={slots.header()}>
        <h3 className={slots.title()}>
          {t('Make an appointment with a doctor')}
        </h3>
        <div className={slots.name()}>{doctor.full_name}</div>
      </div>

      <div className={slots.content()}>
        <div className={slots.info()}>
          {doctor.clinics && doctor.clinics.length > 0 && (
            <UiDoctorSelectorCity
              size="xs"
              city={doctor.city || ''}
            />
          )}
          {doctor.clinics && (
            <span className={slots.count()}>
              {doctor.clinics.length} {pluralizeClinics(doctor.clinics.length)}
            </span>
          )}
        </div>

        {doctor.clinics && (
          <div className={slots.addresses()}>
            {doctor.clinics.map((item: Clinic, idx: number) => (
              <div
                key={item?.name || idx}
                className={slots.address()}
              >
                <BenefitIcon className={slots.addressIcon()} />
                <div className={slots.addressContent()}>
                  <p className={slots.addressName()}>{item.name}</p>
                  <p className={slots.addressLine()}>{item.address}</p>
                  <a
                    href={`tel:${item.telephone}`}
                    className={slots.addressPhone()}
                  >
                    {item.telephone}
                  </a>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
